/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import placeholder from '../../assets/cruise-placeholder.jpg';
import {
  cruiseTitle,
  formatDateRange,
  nightsOf,
} from '../../utils/cruiseUtils';

/** Sidebar card: cruise header plus label/value rows and a footer slot. */
function CruiseTripSummary({ cruise, rows, showImage, children }) {
  return (
    <div className="cr-panel cr-trip">
      {showImage && <img className="cr-trip__img" src={placeholder} alt="" />}
      <div className="cr-trip__body">
        <b className="cr-trip__title">{cruiseTitle(cruise.cruiseName)}</b>
        <div className="cr-muted-sm">
          {[
            cruise.shipName,
            `${nightsOf(cruise)} Nights`,
            formatDateRange(cruise.startDate, cruise.endDate),
          ]
            .filter(Boolean)
            .join(' · ')}
        </div>
        {rows.length > 0 && (
          <div className="cr-kv cr-kv--dashed">
            {rows
              .filter((r) => r.value)
              .map((r) => (
                <div className="cr-kv__row" key={r.label}>
                  <span>{r.label}</span>
                  <b>{r.value}</b>
                </div>
              ))}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

CruiseTripSummary.propTypes = {
  cruise: PropTypes.object.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.node }),
  ),
  showImage: PropTypes.bool,
  children: PropTypes.node,
};

CruiseTripSummary.defaultProps = {
  rows: [],
  showImage: true,
  children: null,
};

export default CruiseTripSummary;
